import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ViewToggle = ({ currentView = "timeline", onViewChange }) => {
  const views = [
    {
      id: "timeline",
      label: "Timeline View",
      icon: "List",
      description: "Vertical timeline layout",
    },
    // {
    //   id: 'tracker',
    //   label: 'Progress Tracker',
    //   icon: 'BarChart3',
    //   description: 'Horizontal progress layout'
    // }
  ];

  return (
    <div className="flex items-center space-x-2 bg-muted rounded-lg p-1">
      {views?.map((view) => (
        <Button
          key={view?.id}
          variant="ghost"
          size="sm"
          onClick={() => onViewChange(view?.id)}
          className={`
            flex items-center space-x-2 px-3 py-2 rounded-md transition-all duration-150
            ${
              currentView === view?.id
                ? "bg-primary/10 shadow-sm"
                : "hover:bg-muted/50"
            }
          `}
          title={view?.description}
        >
          <Icon
            name={view?.icon}
            size={16}
            color="currentColor"
            strokeWidth={2}
          />
          <span className="font-medium">{view?.label}</span>
        </Button>
      ))}
    </div>
  );
};

export default ViewToggle;
